import Model from "./model";
import WebhookUser from "../api/model/webhooks/WebhookUser";
import WebhookDetails from "../api/model/webhooks/WebhookDetails";
import WebhookSubscriptions from "../api/model/webhooks/WebhookSubscriptions";

interface WebhookData extends WebhookDetails {
    complete?: boolean;
}

class Webhook extends Model {
    id: string;
    _id: string;
    url: string;
    status: "active" | "inactive";
    urlHealth: "healhty" | "unhealthy";
    subscriptions?: WebhookSubscriptions;
    subscribedAllEvents?: boolean;
    createdBy?: WebhookUser;
    updatedBy?: WebhookUser;
    created: string;
    updated: string;
    oauthApp?: string;
    complete?: boolean;

    constructor(webhook: WebhookData) {
        super();

        const {
            _id,
            url,
            status,
            urlHealth,
            subscriptions,
            subscribedAllEvents,
            createdBy,
            updatedBy,
            created,
            updated,
            oauthApp,
            complete
        } = webhook;

        this.id = _id;
        this._id = _id;
        this.url = url;
        this.status = status;
        this.urlHealth = urlHealth;
        this.subscriptions = subscriptions;
        this.subscribedAllEvents = subscribedAllEvents;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.created = created;
        this.updated = updated;
        this.oauthApp = oauthApp;
        this.complete = complete;
    }
}

export default Webhook;
export {
    WebhookData
};
